<template>
  <div v-if="model" id="reservation">
    <div id="content">
      <h1>{{ lang.new_user }}</h1>

      <div class="row">
        <div class="col-md-10">
          <Form
            ref="form"
            :requiredFields="required_fields"
            :onSubmit="onSubmit"
            :onSuccess="onSuccess"
          >
            <div class="row">
              <div class="col-md-6">
                <fieldset class="bg-white rounded p-3 mb-3">
                  <div class="form-group row">
                    <div class="col-sm-12">
                      <h2>{{ lang.personal_details }}</h2>
                    </div>
                  </div>

                  <TextInput :label="lang.name" :model="model" name="name" />

                  <TextInput :label="lang.email" :model="model" name="email" />

                  <TextInput :label="lang.phone" :model="model" name="phone" />
                </fieldset>
              </div>

              <div class="col-md-6">
                <fieldset class="bg-white rounded p-3 mb-3">
                  <h2>{{ lang.account_details }}</h2>

                  <TextInput
                    :label="lang.username"
                    :placeholder="lang.username_placeholder"
                    :model="model"
                    name="username"
                  />

                  <Select :label="lang.role" :model="model" :options="roles" name="role_id" />

                  <Select
                    :label="lang.country"
                    :model="model"
                    :options="countries"
                    name="country_id"
                  />

                  <TextInput :label="lang.password" :secure="true" :model="model" name="password" />

                  <TextInput
                    :label="lang.confirm_password"
                    :secure="true"
                    :model="model"
                    name="password_confirmation"
                  />
                </fieldset>

                <div class="form-group row mt-2 mb-5">
                  <div class="col-md-6">
                    <a href class="btn btn-primary w-50">{{ i18n.buttons.cancel }}</a>
                  </div>
                  <div class="col-md-6 pr-0 text-right">
                    <a @click="onSubmitPress" class="btn btn-secondary w-50">{{ i18n.buttons.save }}</a>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import User from "@/models/User";
import Vehicle from "@/models/Vehicle";
import { Form, HiddenInput, TextInput, Select } from "@/components/common/form";
import UserService from "@/services/UserService";

const userService = new UserService();

export default {
  name: "user-edit",
  components: {
    Form,
    HiddenInput,
    TextInput,
    Select
  },
  data() {
    return {
      lang: i18n.app.components.user,
      required_fields: this.$route.params.required_fields,
      countries: this.$route.params.countries,
      roles: this.$route.params.roles,
      model: null
    };
  },
  mounted() {
    if (!this.model) {
      const model = new User();
      model.country_id = this.$store.state.user.preference.country_id;
      this.model = model;
    }
  },
  methods: {
    onSubmitPress() {
      this.$refs.form.submit(this.model);
    },
    onSuccess() {
      this.$router.push("/users");
    },
    onSubmit(model) {
      return userService.insert(model);
    }
  }
};
</script>
